import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-plus',
  imports: [],
  template: `<svg
  width="14"
  height="14"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_482_3624)">
    <path
      d="M12.3301 9.74461V1.27687C12.3301 1.00738 12.223 0.748921 12.0325 0.558359C11.8419 0.367798 11.5835 0.260742 11.314 0.260742C11.0445 0.260742 10.786 0.367798 10.5955 0.558359C10.4049 0.748921 10.2978 1.00738 10.2978 1.27687V9.74461H1.83009C1.5606 9.74461 1.30214 9.85167 1.11158 10.0422C0.921021 10.2328 0.813965 10.4912 0.813965 10.7607C0.813965 11.0302 0.921021 11.2887 1.11158 11.4793C1.30214 11.6698 1.5606 11.7769 1.83009 11.7769H10.2978V20.2446C10.3013 20.513 10.4095 20.7694 10.5993 20.9592C10.7891 21.149 11.0456 21.2572 11.314 21.2607C11.5835 21.2607 11.8419 21.1537 12.0325 20.9631C12.223 20.7726 12.3301 20.5141 12.3301 20.2446V11.7769H20.7978C21.0673 11.7769 21.3258 11.6698 21.5163 11.4793C21.7069 11.2887 21.814 11.0302 21.814 10.7607C21.8105 10.4923 21.7023 10.2359 21.5125 10.0461C21.3227 9.85631 21.0662 9.74812 20.7978 9.74461H12.3301Z"
      [attr.fill]="color"
    />
  </g>
  <defs>
    <clipPath id="clip0_482_3624">
      <rect
        width="21"
        height="21"
        fill="white"
        transform="translate(0.813965 0.260742)"
      />
    </clipPath>
  </defs>
</svg>
`
})
export class PlusComponent {
  @Input() color: string = '#000';
}
